/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsBlobDto } from '../models/Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsBlobDto';
import type { Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsDto } from '../models/Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsDto';
import type { Wealthlane_AwardService_Dtos_Plan_PlanWithPoolDropdownDto } from '../models/Wealthlane_AwardService_Dtos_Plan_PlanWithPoolDropdownDto';
import type { Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO } from '../models/Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GrantAppSharedService {
  /**
   * @param grantId
   * @returns Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsDto OK
   * @throws ApiError
   */
  public static getApiAwardApiAppGrantActiveTermsAndConditions(
    grantId: string
  ): CancelablePromise<Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/app/grant/active-terms-and-conditions/{grantId}',
      path: {
        grantId: grantId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param grantId
   * @returns Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsBlobDto OK
   * @throws ApiError
   */
  public static postApiAwardApiAppGrantDownloadTermsAndConditionsDocumentByParticipant(
    grantId: string
  ): CancelablePromise<Wealthlane_AwardService_Dtos_Grant_GrantTermsAndConditionsBlobDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/grant/download-terms-and-conditions-document-by-participant/{grantId}',
      path: {
        grantId: grantId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @returns Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO OK
   * @throws ApiError
   */
  public static getApiAwardApiAppGrantAcceptanceMethodList(): CancelablePromise<
    Array<Wealthlane_AwardService_Dtos_RSUAward_GetStatusDTO>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/app/grant/acceptance-method-list',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @returns Wealthlane_AwardService_Dtos_Plan_PlanWithPoolDropdownDto OK
   * @throws ApiError
   */
  public static getApiAwardApiAppGrantAppSharedPlansWithPoolForDropdown(): CancelablePromise<
    Array<Wealthlane_AwardService_Dtos_Plan_PlanWithPoolDropdownDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/app/grant-app-shared/plans-with-pool-for-dropdown',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
